// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2CRAG","cell":"ColumnAccessor_cell__2xyZ7","firstCellAccent":"ColumnAccessor_firstCellAccent__3lltw"};